module.exports = __webpack_public_path__ + "img/one_3.1c2eb4fd.png";